var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.398c5.854 0 10.6 4.746 10.6 10.6s-4.746 10.6-10.6 10.6-10.6-4.746-10.6-10.6 4.746-10.6 10.6-10.6m0 1.2a9.4 9.4 0 1 0 0 18.801 9.4 9.4 0 0 0 0-18.801m4.082 4.685a.502.502 0 0 1 .632.633l-2.12 6.36a.5.5 0 0 1-.316.316l-6.36 2.12a.5.5 0 0 1-.633-.632l2.12-6.36.05-.106a.5.5 0 0 1 .267-.21zm-5.808 2.99L8.55 15.447l5.175-1.724 1.724-5.175z"
  })));
};
export default SvgCompass;